/* ============================================================
   HeadKnobs theme — homepage enhancements
   The "A Catalogue" homepage is content-light: the only live behaviour
   is the sticky header, smooth-scroll nav (CSS), and hover states. The
   Style / Shape / Finish cards are presentational previews — real
   selection lives in the upload/configurator flow. This script just adds
   a small click-to-highlight nicety on those cards within each group.
   ============================================================ */

(function () {
  'use strict';

  function setupCardGroups() {
    document.querySelectorAll('[data-hk-group]').forEach(function (group) {
      var cards = group.querySelectorAll('.hk-card');
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        });
      });
    });
  }

  function init() {
    setupCardGroups();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
